import React from "react"

import ImageComplete from "./ImageComplete.js"

import { Row, Col } from "react-bootstrap"
import TitleLight from "../../components/typography/TitleLight.js"
import TitleBold from "../../components/typography/TitleBold.js"

export default function RightImageCard(props) {
  return (
    <>
      <Row className="text-center mt-5">
        <Col lg={(6, { order: "last" })} className="text-center mt-5">
          <ImageComplete
            alt={props.alt}
            src={props.src}
            className={props.className}
            width={props.width}
            height={props.height}
          />
        </Col>
        <Col
          lg={(6, { order: "first" })}
          className="text-center mt-5 align-self-center"
        >
          <h2 className="display-6">
            <TitleBold>{props.titleH2}</TitleBold>
          </h2>
          <h3 className="mt-5">
            <TitleLight>{props.titleH3}</TitleLight>
          </h3>
        </Col>
      </Row>
    </>
  )
}
